import type { ReactNode } from "react";

import type { IconName } from "@similarweb/icons";
import { FlexColumn } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

import {
    TooltipContentWrapper,
    PopupHoverContainerTitle,
    PopupHoverContainerUrl,
    PopupHoverContainerYourUrl,
    PopupHoverContainerYourUrlText,
    PopupHoverContainerYourUrlTitle,
    PopupHoverContainerYourUrlTitleWrapper,
    PopupHoverIcon,
} from "./styles";

type Props = {
    displayedSite: string;
    targetUrls: string[];
    iconName: string;
    iconColor: string;
    extraContent?: ReactNode;
};

export const TargetUrlTooltipContent = ({ displayedSite, targetUrls, iconName, iconColor, extraContent }: Props) => {
    const showYourTargetUrl = iconName === "alert-circle";
    const tooltipTitle = translate("rankTracker.keywordsReport.targetUrl.tooltip.title");
    const yourTargetUrl = translate("rankTracker.keywordsReport.targetUrl.tooltip.yourUrl");
    const isUrlsMatchText = showYourTargetUrl
        ? translate("rankTracker.keywordsReport.targetUrl.tooltip.mismatch")
        : translate("rankTracker.keywordsReport.targetUrl.tooltip.match");
    const isDisplayedUrlExists =
        displayedSite !== "" ? displayedSite : translate("rankTracker.targetUrl.tooltip.noTopUrl");

    return (
        <TooltipContentWrapper>
            <PopupHoverContainerTitle>{tooltipTitle}</PopupHoverContainerTitle>
            <PopupHoverContainerUrl>{isDisplayedUrlExists}</PopupHoverContainerUrl>
            {targetUrls?.length > 0 ? (
                <>
                    <PopupHoverContainerYourUrlTitleWrapper>
                        <PopupHoverIcon
                            iconName={iconName as IconName}
                            iconColor={iconColor}
                            size="xs"
                        />
                        <PopupHoverContainerYourUrlTitle>{isUrlsMatchText}</PopupHoverContainerYourUrlTitle>
                    </PopupHoverContainerYourUrlTitleWrapper>
                    {showYourTargetUrl ? (
                        <FlexColumn>
                            <PopupHoverContainerYourUrlText>{yourTargetUrl}</PopupHoverContainerYourUrlText>
                            <PopupHoverContainerYourUrl>{targetUrls[0]}</PopupHoverContainerYourUrl>
                        </FlexColumn>
                    ) : null}
                </>
            ) : null}
            {extraContent}
        </TooltipContentWrapper>
    );
};
